module.exports = __webpack_public_path__ + "static/media/1200px-Celgene_logo.svg.362ae859.png";